export const defaultWinnerWheelUsers = [{ id: 1, body: 'Deepak' }, { id: 2, body: 'Tom' }, { id: 3, body: 'Mina' },
  { id: 4, body: 'Daniel' }, { id: 5, body: 'Ryan' }, { id: 6, body: 'Emily' },
  { id: 7, body: 'Helen' }, { id: 8, body: 'Will' }, { id: 9, body: 'Aishwarya' },
  { id: 10, body: 'Amitabh' }, { id: 11, body: 'Angelina' }, { id: 12, body: 'Benedict' },
  { id: 13, body: 'Brad' }, { id: 14, body: 'Chris' }, { id: 15, body: 'Dwayne' },
  { id: 16, body: 'Emma' }, { id: 17, body: 'Hugh' }, { id: 18, body: 'Jared' },];
export const wheelPreviewCheck = ({ setOpts, setNoUser, setWheelState, opts }) => {
  if (opts?.length < 18) {
    setOpts((prev) => [...prev.filter((comment) => !comment.body.includes('Option')), ...defaultWinnerWheelUsers.slice(0, 18 - prev?.length)]);
  }
  setNoUser(false);
  setWheelState(false);
};
